import { AppEnvSchema } from './schema'

export type { AppEnv } from './schema'
export { AppEnvSchema } from './schema'

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        __ENV__: unknown
    }
}

const useBuiltInEnv =
    import.meta.env.DEV ||
    // eslint-disable-next-line local/restricted-import-meta-env
    import.meta.env.VITE_PRODUCT_ENV === 'production'

// eslint-disable-next-line local/restricted-import-meta-env
const result = AppEnvSchema.safeParse(useBuiltInEnv ? import.meta.env : window.__ENV__)

if (!result.success) {
    throw new Error(
        `Invalid runtime config. Ensure the runtime config script is loaded before the app bundle. ${result.error.message}`
    )
}

export const env = result.data
